//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: () => ({
    form: {
      id: "", //项目id
      ids: "", //交易订单
      projectName: "",
      invoiceAmount: 0,
      invoiceType: 1,
      buyerName: "",
      buyerTaxCode: "",
      buyerAddress: "",
      buyerPhone: "",
      buyerBankName: "",
      buyerBankAccount: "",
      addressee: "",
      contactNumber: "",
      mailbox: "",
      invoiceLocation: {
        addressee: "",
        contactNumber: "",
        mailbox: "",
      },
    },
    row: "",
    rules: {
      invoiceType: {
        required: true,
        message: "请选择发票类型",
        trigger: "change",
      },
      buyerName: {
        required: true,
        message: "请填写开票单位全称",
        trigger: "change",
      },
      buyerTaxCode: {
        required: true,
        message: "请填写纳税人识别号",
        trigger: "blur",
      },
      buyerAddress: { required: true, message: "请填写地址", trigger: "blur" },
      buyerBankName: {
        required: true,
        message: "请填写开户行",
        trigger: "blur",
      },
      buyerBankAccount: {
        required: true,
        message: "请填写账号",
        trigger: "blur",
      },
      addressee: {
        required: true,
        message: "请填写收件人名称",
        trigger: "blur",
      },
    },
  }),
  methods: {
    // 自动补全信息(开票名称展示)
    querySearch(queryString, cb) {
      this.$get(
        "/pay/invoice/backFillList",
        {
          title: queryString,
          pageIndex: 1,
          pageSize: 6,
        },
        function (res) {
          var firmList = res.data.records;
          var results = queryString
            ? firmList.filter(this.createFilter(queryString))
            : firmList;
          cb(results);
        }
      );
    },
    createFilter(queryString) {
      return (state) => {
        return state;
      };
    },
    // 选择数据(开票单位名称)
    handleSelect(e) {
      this.form.buyerName = e.buyerName;
      this.form.buyerTaxCode = e.buyerTaxCode;
      this.form.buyerAddress = e.buyerAddress;
      this.form.buyerPhone = e.buyerPhone;
      this.form.buyerBankName = e.buyerBankName;
      this.form.buyerBankAccount = e.buyerBankAccount;
    },

    // 开票保存
      saveInvoice(form){
        this.form.invoiceLocation.addressee = this.form.addressee;
        this.form.invoiceLocation.contactNumber = this.form.contactNumber;
        this.form.invoiceLocation.mailbox = this.form.mailbox
        this.$refs[form].validate((valid) => {
          if(valid){
            this.$post('/pay/invoice',this.form,function(res){
              if(res.code==200){
                this.$message.success('已申请开票!');
                this.$router.go(-1);
              }
            },true)
          }
        })
      },


  },
  mounted() {
    this.form.invoiceAmount = this.$route.query.invoiceAmount;
    this.form.ids = this.$route.query.ids;
    this.form.projectName = this.$route.query.projectName;
  },
};
